/* eslint-disable */
import React from 'react'
import { Field } from 'redux-form'
import { InputCheckbox, FilterContainer, FilterTypes, Container, Content, ListItem, Title, TitleContainer, CheckBoxContainer, CheckboxLabel } from './styles'

const filterItems = [
  {
    value: "ESTACIONAMENTO",
    label: 'Estacionamento',
  },
  {
    value: "PEDAGIO",
    label: 'Pedágio',
  }
]

const renderCheckboxItem = props => {
    const inputValue = props.input.value
    return (
      <InputCheckbox
        {...props}
        onChange={e => {
          const arr = [...inputValue]
          if (e.target.checked) {
            arr.push({tipo: props.typeValue})
          } else {
            arr.splice(arr.indexOf(props.typeValue), 1)
          }
          props.input.onChange(arr)
          props.setTypeRef(e.target)
        }}
        value={props.input.value}
        type="checkbox"
      />
    )
  }
  
  function CheckboxItem(props) {
    return (
      <CheckBoxContainer>
        <Field component={renderCheckboxItem} {...props} />
        <CheckboxLabel>{props.label}</CheckboxLabel>
      </CheckBoxContainer>
    )
  }

function FilterByType(props) {
  return (
    <Container>
      <Content>
        <TitleContainer>
          <Title>Tipo de transação</Title>
        </TitleContainer> 
        <FilterContainer>
          <FilterTypes>
            {filterItems.map((type, index) => {
              return(
              <ListItem key={type.value}>
                <CheckboxItem
                  setTypeRef={props.setTypeRef}
                  typeValue={type.value}
                  onChange={props.onChange}
                  name='type'
                  label={type.label}
                  index={index}
                />
              </ListItem>
            )})}
          </FilterTypes>
        </FilterContainer>
      </Content>
    </Container>
  )
}

export default FilterByType



// WEBPACK FOOTER //
// ./src/app/pages/DashboardStatementPartner/PartnerStatementsFilter/PartnerFilterForm/FilterByType/FilterByType.js